const ApiBase = require('./api');

function SetingsFactory () {
  this.resource = 'inkiveeditor/updateSettings';
  this.baseUrl = INKIVE.C.BASE_URL;
}

SetingsFactory.prototype = new ApiBase();

SetingsFactory.prototype.set = function (data) {
  const deferred = $.Deferred();

  data = _.extend({
    name: Base64.decode(INKIVE.C.BOOK.name),
    description: Base64.decode(INKIVE.C.BOOK.description),
    category: INKIVE.C.BOOK.category,
    security: INKIVE.C.BOOK.security
  }, data);

  if (this.data) {
    deferred.resolve(this.data);
  } else {
    this.api(this.resource, {
      idInkive: INKIVE.C.BOOK.id,
      data: _.map(data, function (value, name) {
        return { name, value };
      })
    }).then(_.bind(function () {
      const encodedContents = ['name', 'description'];

      _.each(data, function (value, name) {
        INKIVE.C.BOOK[name] = _.contains(encodedContents, name)
          ? Base64.encode(value)
          : value;
      });

      this.trigger('update');
      deferred.resolve();
    }, this), function (err) {
      deferred.reject(err + ' | API Init error');
    });
  }

  return deferred.promise();
};

module.exports = new SetingsFactory();
